import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const items = [{
  label: 'GIA certified diamonds',
  desc: 'Independently graded'
}, {
  label: 'Conflict-free sourcing',
  desc: 'Every stone, every time'
}, {
  label: 'Premium cut diamonds',
  desc: 'Where cut matters most'
}, {
  label: 'Coloured diamonds',
  desc: 'Champagne, cognac, pink'
}, {
  label: 'South Sea pearls',
  desc: 'Hand-strung to order'
}, {
  label: 'Sapphires & emeralds',
  desc: 'Australian and Ceylon'
}, {
  label: '18ct gold & platinum',
  desc: 'All on-site casting'
}, {
  label: 'Bridal & wedding bands',
  desc: 'Matched sets a speciality'
}];
export function Diamonds() {
  return <section id="diamonds" className="section-padding bg-primary text-white relative overflow-hidden" data-id="element-118">
      <div className="absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'radial-gradient(var(--color-gold-light) 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-119" />

      <div className="container-custom relative z-10" data-id="element-120">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-121">
          <div className="lg:col-span-5" data-id="element-122">
            <span className="eyebrow-light" data-id="element-123">Diamonds &amp; Fine Jewellery</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] font-medium leading-[1.1] mb-6 text-balance text-white" data-id="element-124">
              Chosen for you —{' '}
              <span className="italic text-gold-light" data-id="element-125">
                not chosen for our shelf.
              </span>
            </h2>
            <p className="text-white/80 text-lg leading-relaxed mb-8 text-pretty" data-id="element-126">
              We source loose diamonds and gemstones to your brief, not from a
              pre-bought tray. You see exactly what your budget can buy, with no
              pressure to settle for what we already have in stock.
            </p>
            <a href="#consultation" className="btn-gold group" data-id="element-127">
              Speak with a diamond specialist
              <ArrowRightIcon className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-128" />
            </a>
          </div>

          <div className="lg:col-span-7" data-id="element-129">
            <div className="relative mb-8 hidden lg:block" data-id="element-130">
              <div className="aspect-[16/10] overflow-hidden bg-gradient-to-br from-navy to-primary border border-gold/20 flex items-center justify-center" data-id="element-131">
                <img src="https://cdn.magicpatterns.com/uploads/i97S84Xv1qcHKn7jhaikdm/d2.webp" alt="A loose marquise diamond set into a custom Sinclairs ring — sourced and matched to a Perth client's brief" className="max-h-full max-w-full object-contain p-10" data-id="element-132" />
              </div>
              <div className="absolute bottom-4 left-4 bg-background text-primary px-4 py-2 shadow-lg" data-id="element-133">
                <p className="brand-mark text-[0.6rem] text-gold-dark uppercase" data-id="element-134">
                  From the Sinclairs bench
                </p>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-px bg-white/10 border border-white/15" data-id="element-135">
              {items.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.04
            }} className="bg-primary p-5 md:p-6" data-id="element-136">
                  <p className="font-serif text-base md:text-lg text-white leading-tight mb-1" data-id="element-137">
                    {item.label}
                  </p>
                  <p className="text-[0.7rem] tracking-[0.15em] uppercase text-gold-light/80" data-id="element-138">
                    {item.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}